import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsDELETE,
  requestOptionsDELETEWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  stops: [],
  unallocatedDeliveries: []
};

const getters = {
  getStops: (state) => state.stops,
  getUnallocatedNfes: (state) => state.unallocatedDeliveries
};

const mutations = {
  setDeliveriesByid(state, payload) {
    state.stops = payload;
  },
  setUnallocatedDeliveriesByid(state, payload) {
    state.unallocatedDeliveries = payload;
  }
};

const actions = {
  getAllStops(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getStopsManualBoarding + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setDeliveriesByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getAllUnallocatedDeliveries(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUnallocatedDeliveries + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setUnallocatedDeliveriesByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNewStop(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createStopManualBoarding + id, requestOptionsPOST(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createGroupedStops(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createGroupedStops + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), { deliveriesIds: model.deliveriesIds })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  allocateDelivery(_, params) {
    const body = {
      deliveriesIds: params.deliveriesIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.allocateDeliveriesManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getDeliveriesByStopId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getDeliveriesByStopIdManualBoarding + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deallocateDelivery(_, params) {
    const body = {
      deliveriesIds: params.deliveriesIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deallocateDeliveriesManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteStop(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteStopManualBoarding + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  deleteMultipleStops(_, ids) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteMultipleStopsManualBoarding,
        requestOptionsDELETEWithBody(localStorage.getItem('accessToken'), { stopsIds: ids })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
